import React, {ReactNode} from "react";
import {css, useTheme} from "@emotion/react";

import {borderRadius, calculateRemSize, flexAbsoluteCenter, onDesktop, p, textAlign, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    graphic: ReactNode;
    title: string;
    description: string;
}

export const PropertyLocationGeneralAttributeBox = (props: IProps) => {
    const theme = useTheme();
    return (
        <div css={wrapperStyle}>
            <div css={graphicWrapperStyle}>{props.graphic}</div>
            <div css={w100}>
                <Text variant="headline_6" mb={1} css={onDesktop(textAlign("center"))}>
                    {props.title}
                </Text>

                <Text variant="info_txt_1" color={theme.colors.gray[800]} css={onDesktop(textAlign("center"))}>
                    {props.description}
                </Text>
            </div>
        </div>
    );
};

const wrapperStyle = css`
    ${p(2)};
    ${borderRadius(2)};
    ${flexAbsoluteCenter};
    flex-direction: row;
    width: 100%;
    background-color: #fff;
    gap: ${calculateRemSize(2)};

    ${onDesktop(css`
        flex-direction: column;
        justify-content: flex-start;
    `)};
`;

const graphicWrapperStyle = css`
    ${flexAbsoluteCenter};
    min-height: 13rem;
    min-width: 13rem;

    ${onDesktop(css`
        min-height: 15rem;
    `)};
`;
import React, {ReactNode} from "react";
import {css, useTheme} from "@emotion/react";

import {borderRadius, calculateRemSize, flexAbsoluteCenter, onDesktop, p, textAlign, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    graphic: ReactNode;
    title: string;
    description: string;
}

export const PropertyLocationGeneralAttributeBox = (props: IProps) => {
    const theme = useTheme();
    return (
        <div css={wrapperStyle}>
            <div css={graphicWrapperStyle}>{props.graphic}</div>
            <div css={w100}>
                <Text variant="headline_6" mb={1} css={onDesktop(textAlign("center"))}>
                    {props.title}
                </Text>

                <Text variant="info_txt_1" color={theme.colors.gray[800]} css={onDesktop(textAlign("center"))}>
                    {props.description}
                </Text>
            </div>
        </div>
    );
};

const wrapperStyle = css`
    ${p(2)};
    ${borderRadius(2)};
    ${flexAbsoluteCenter};
    flex-direction: row;
    width: 100%;
    background-color: #fff;
    gap: ${calculateRemSize(2)};

    ${onDesktop(css`
        flex-direction: column;
        justify-content: flex-start;
    `)};
`;

const graphicWrapperStyle = css`
    ${flexAbsoluteCenter};
    min-height: 13rem;
    min-width: 13rem;

    ${onDesktop(css`
        min-height: 15rem;
    `)};
`;
